import UserSelectPage from "@/features/session/pages/UserSelect";

const UserSelect = () => {
  return <UserSelectPage />;
};

export default UserSelect;
